import { ApplicationSkeletonState } from '../skeleton-state/generateSkeletonState';
import { useRedirectToHelpDesk } from './routing/hooks/useRedirectToHelpDesk';
import { jsx as _jsx } from "react/jsx-runtime";
const HelpDeskContainer = () => {
  useRedirectToHelpDesk();
  return /*#__PURE__*/_jsx(ApplicationSkeletonState, {});
};
HelpDeskContainer.displayName = 'HelpDeskContainer';
export default HelpDeskContainer;